var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgCircularGradient = function SvgBgCircularGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 1004,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bg-circular-gradient_svg__b",
    width: 1945,
    height: 1356,
    x: -252,
    y: -176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg-circular-gradient_svg__a)",
    fillOpacity: 0.42,
    d: "M-252-176h1944.86v1356H-252z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.572,
    mask: "url(#bg-circular-gradient_svg__b)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bg-circular-gradient_svg__c)",
    d: "M997.932 493.896c0 148.434-124.218 268.805-277.502 268.805-153.283 0-277.501-120.371-277.501-268.805 0-148.433 124.218-268.805 277.501-268.805 153.284 0 277.502 120.372 277.502 268.805Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.038,
    cy: 373.038,
    r: 372.252,
    stroke: "url(#bg-circular-gradient_svg__d)",
    opacity: 0.5,
    transform: "scale(1.01574 .984) rotate(45 385.568 843.341)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.389,
    cy: 481.389,
    r: 480.603,
    stroke: "url(#bg-circular-gradient_svg__e)",
    opacity: 0.3,
    transform: "scale(1.01574 .984) rotate(-45 620.116 216.59)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bg-circular-gradient_svg__f)",
    d: "M1326.53 493.896c0 324.243-271.34 587.134-606.1 587.134-334.764 0-606.101-262.891-606.101-587.134 0-324.242 271.337-587.135 606.101-587.135 334.76 0 606.1 262.893 606.1 587.135Z",
    opacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-circular-gradient_svg__a",
    x1: 720.43,
    x2: 720.43,
    y1: -176,
    y2: 1180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-circular-gradient_svg__c",
    x1: 442.11,
    x2: 640.615,
    y1: 763.464,
    y2: 169.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-circular-gradient_svg__d",
    x1: -0.043,
    x2: 281.637,
    y1: 746.043,
    y2: -70.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-circular-gradient_svg__e",
    x1: -0.056,
    x2: 363.44,
    y1: 962.736,
    y2: -91.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-circular-gradient_svg__f",
    x1: 113.473,
    x2: 546.371,
    y1: 1081.77,
    y2: -213.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgBgCircularGradient;